// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__Nadkc","header":"Modal_header__XFQ1e","body":"Modal_body__UWyGD","children":"Modal_children__aFl2q"};